/*
  Manual Registrations: the real API (Product Admin token, /api/product-admin/manual-registrations).
  Same methods and data shapes as the demo store in manualRegistrationsApi.js, so the screens do not care
  which one they talk to. Errors are axios errors: err.response.status / err.response.data.error.
*/
import api from '../../services/api';

const BASE = '/product-admin/manual-registrations';
const data = (response) => response.data.data;

export const realApi = {
  plans: () => api.get(`${BASE}/plans`).then(data),

  searchCompanies: (search) => api.get(`${BASE}/companies`, { params: { search } }).then(data),

  getCompany: (id) => api.get(`${BASE}/companies/${id}`).then(data),

  stats: () => api.get(`${BASE}/stats`).then(data),

  listPaidHistory: ({ page = 1, pageSize = 10, search = '', status = '', paidVia = '', changeType = '' } = {}) => api.get(BASE, {
    params: {
      page, page_size: pageSize, search, status, paid_via: paidVia, change_type: changeType,
    },
  }).then(data),

  getRegistration: (id) => api.get(`${BASE}/${id}`).then(data),

  companyHistory: (companyId) => api.get(`${BASE}/companies/${companyId}/history`).then(data),

  // The receipt is private: it is fetched with the admin token and shown from a temporary object URL
  receiptUrl: async (registrationId) => {
    const response = await api.get(`${BASE}/${registrationId}/proof`, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  },

  // multipart: the form values as JSON in `data`, the receipt in `proof`
  createRegistration: ({ proof, ...values }) => {
    const body = new FormData();
    body.append('data', JSON.stringify(values));
    body.append('proof', proof, proof.name);
    return api.post(BASE, body, { headers: { 'Content-Type': 'multipart/form-data' } }).then(data);
  },

  cancelRegistration: (id, reason) => api.post(`${BASE}/${id}/cancel`, { reason }).then(data),
};
